import axios from 'axios';

axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

// 设置环境 "http://localhost:9005" 测试环境106.52.40.63
var dev = "http://localhost:9005";
var test = "https://www.ioofox.com:9005";
//var pro = "http://www.halababy.com:9005";
export var ip = test;
export function post(urlPath, params = {}) {
    let url = ip + urlPath;
    let obj = new FormData();
    for (let key in params) {
        obj.append(key, params[key]);
    }
    return new Promise((resolve, reject) => {
        axios.post(url, obj)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

export function download(url, params = {}, name) {
    let disorderlyName = url.substring(url.lastIndexOf("/")+1);
    let fileName = name + disorderlyName.substring(disorderlyName.lastIndexOf("."));
    return new Promise((resolve, reject) => {
        axios.get(url, {
            responseType: 'blob'   //首先设置responseType字段格式为 blob
        }).then(res => {
            let blob = new Blob([res.data]);
            let aurl = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
            let a = document.createElement("a");
            a.href = aurl;
            a.setAttribute('download',fileName);
            a.click();
            // 释放资源
            window.URL.revokeObjectURL(aurl);
        });
    })
}

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}



// WEBPACK FOOTER //
// ./src/utils/http.js